import React, { Component } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "./style/App.css" 
import { Carousel } from "react-responsive-carousel";

export default class featured extends Component {
  render() {
    return (
        <div id={'ourteam1'} >
     <div className='choose-choose-container'>
     <center >
              <div className='choose-choose-header'>
              <h1 >Bike Rental Team</h1>
              </div >
              <div ><h3>Asansol Engineering College</h3></div>
     </center>
     </div>
      <Carousel
        showArrows={true}
        infiniteLoop={true}
        showThumbs={false}
        showStatus={false}
        autoPlay={true}
        interval={2800}
      >
        <div>
          {/* <img src="/shirley.png" /> */}
          <div className="myCarousel">
            <h3>Akshat Narayan Gupta</h3>
            <h4>Full-Stack Developer</h4>
            <h5>Contact at:- <b>akshat.narayangupta@gmail.com</b></h5>
            <p>
              It's freeing to be able to catch up on customized news and not be
              distracted by a social media element on the same site
            </p>
          </div>
        </div>

        <div>
          {/* <img src="/daniel.png" /> */}
          <div className="myCarousel">
          <h3>Gaurav Kumar Singh</h3>
            <h4>Frontend Developer</h4>
            <h5>Contact at:- <b>gauravsingha32@gmail.com</b></h5>
            <p>
              The simple and intuitive design makes it easy for me use. I highly
              recommend Fetch to my peers.
            </p>
          </div>
        </div>

        <div>
          {/* <img src="/theo.png" /> */}
          <div className="myCarousel">
            <h3>Barsha Bhattacharya</h3>
            <h4>Backend Developer</h4>
            <h5>Contact at:- <b>barshabhattacharya712@gmail.com</b></h5>
            <p>
              I enjoy catching up with Fetch on my laptop, or on my phone when
              I'm on the go!
            </p>
          </div>
        </div>
        <div>
          {/* <img src="/theo.png" /> */}
          <div className="myCarousel">
            <h3>Arya Tewary</h3>
            <h4>Backend Developer</h4>
            <h5>Contact at:- <b>tewaryarya@gmail.com</b></h5>
            <p>
              I enjoy catching up with Fetch on my laptop, or on my phone when
              I'm on the go!
            </p>
          </div>
        </div>
        <div>
          {/* <img src="/theo.png" /> */}
          <div className="myCarousel">
            <h3>Ananya Kumar</h3>
            <h4>Frontend Developer</h4>
            <h5>Contact at:- <b>ananya15606@gmail.com</b></h5>
            <p>
              I enjoy catching up with Fetch on my laptop, or on my phone when
              I'm on the go!
            </p>
          </div>
        </div>
      </Carousel>
      </div>
    );
  }
}